export const TAG_COLOR_INFO = [
  { name: '蓝色', color: '#0066FF', backgroundColor: '#F0F6FF', borderColor: '#C2DAFF' },
  { name: '天蓝', color: '#28A2FA', backgroundColor: '#EBF6FF', borderColor: '#CCEAFF' },
  { name: '青色', color: '#2BDEEA', backgroundColor: '#EBFEFF', borderColor: '#CCFCFF' },
  { name: '绿色', color: '#00C788', backgroundColor: '#E6FAF4', borderColor: '#C9F0E3' },
  { name: '黄色', color: '#FAC228', backgroundColor: '#FFF8E5', borderColor: '#FFECB8' },
  { name: '橙色', color: '#F57E22', backgroundColor: '#FFF3EB', borderColor: '#FFDFC7' },
  { name: '红色', color: '#DB3543', backgroundColor: '#FFEBEC', borderColor: '#FFD6D9' },
  { name: '紫色', color: '#A910E5', backgroundColor: '#F9EBFF', borderColor: '#F0C9FF' },
  { name: '暗紫', color: '#5410E5', backgroundColor: '#F2ECFF', borderColor: '#D8C6FF' },
  { name: '中蓝', color: '#333AFF', backgroundColor: '#F0F0FF', borderColor: '#D6D8FF' },
];
